import { Dialog, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    paddingTop: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
})) as typeof Dialog;

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.hhglobal.neutral.gray50,
})) as typeof DialogTitle;

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  borderTop: `1px solid ${theme.hhglobal.neutral.gray400}`,
})) as typeof DialogActions;

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.hhglobal.spacing.spacing[4].valuePx,
})) as typeof DialogContent;
